import { useEffect } from 'react';

const useClickAway = ({ refs = [], callback, isActive = true }) => {
  useEffect(() => {
    if (!isActive) return;

    const handleClickAway = (event) => {
      const clickedInsideAny = refs.some((ref) => ref.current?.contains(event.target));
      if (!clickedInsideAny) {
        callback?.();
      }
    };

    document.addEventListener('click', handleClickAway);
    return () => document.removeEventListener('click', handleClickAway);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs, callback, isActive]);
};

export default useClickAway;
